<template>
  <div ref="autocomplete" class="autocomplete-container">
    <v-autocomplete
      :attach="$refs.autocomplete"
      :loading="Project.fetching"
      v-model="selectedProjectId"
      :search-input.sync="searchQuery"
      class="project-autocomplete"
      :items="searchResults"
      item-text="name"
      item-value="id"
      hide-no-data
      solo
      label="Search Project"
      outlined
      dense
      @input="onSelected"
      :filter="() => true"
      :menu-props="{ offsetY: true }"
    >
      <template v-slot:item="{ item }" class="cursor-pointer">
        <v-list-item-avatar tile small contain size="36">
          <v-img :src="getMedia(item)" :alt="item.name" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.name" />
          <!--          <v-list-item-subtitle-->
          <!--            v-html="item.description"-->
          <!--          ></v-list-item-subtitle>-->
        </v-list-item-content>
        <v-list-item-action v-if="currentUser.isTourist()">
          <v-btn
            class="project-details-btn"
            icon
            @click.prevent.stop="projectDetail = item"
          >
            <v-icon color="grey lighten-1">$information</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
      <template v-slot:selection="{ item }">
        <div>
          <v-avatar tile small contain size="32" class="grey-bg rounded">
            <v-img :src="getMedia(item)" :alt="item.name" />
          </v-avatar>

          {{ item.name }}
        </div>
      </template>
      <template #no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-center">
              No projects to select yet
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template #append-item>
        <div
          ref="scrollTarget"
          v-intersect="onIntersect"
          class="scroll-target"
        ></div>
      </template>
    </v-autocomplete>

    <Drawer
      class="project-details"
      width="500"
      :class="!!operatorId && 'secondary-drawer'"
      @close="projectDetail = null"
      v-if="!!projectDetail && currentUser.isTourist()"
      :value="true"
      color="#F5F7FB"
    >
      <template v-slot:child>
        <v-container class="px-5 px-md-18 py-14 py-md-8 pa-md-20">
          <v-img
            height="250"
            :src="getMedia(projectDetail)"
            :alt="projectDetail.name"
          />
          <v-card-title
            class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
          >
            {{ projectDetail.name }}
          </v-card-title>

          <v-card-text class="pa-0">
            <div v-html="projectDetail.description" />
          </v-card-text>
        </v-container>
      </template>

      <template v-slot:append>
        <div class="px-5 px-md-20 py-12">
          <v-btn block large class="primary" @click="projectDetail = null">
            Done
          </v-btn>
        </div>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Project from '@models/Project';

import Drawer from '@layouts/_partials/Drawer';

export default {
  name: 'ProjectSelector',
  components: {
    Drawer,
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    operatorId: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      projectDetail: null,
      searchQuery: '',
      mounted: false,
      searchResults: [],
    };
  },
  computed: {
    selectedProjectId: {
      get() {
        return this.value;
      },
      set(projectId) {
        this.$emit('input', projectId);
      },
    },
  },
  watch: {
    searchQuery: {
      handler(search) {
        if (!this.mounted) {
          return;
        }

        this.Project.setPage(1);
        this.Project.setFilters({
          name: search,
        });
        this.fetchProjects();
      },
      immediate: false,
    },
  },

  methods: {
    async fetchProjects() {
      const response = await this.Project.get();

      if (this.Project.page === 1) {
        this.searchResults = [];
      }
      if (response) {
        this.searchResults.push(...response.data);
        this.Project.setPage(response.pagination.current_page);
        this.Project.setLimit(response.pagination.per_page);
        this.Project.setTotal(response.pagination.total);
        this.Project.setTotalPages(response.pagination.last_page);
        if (!this.value && response.data.length) {
          this.selectedProjectId = response.data[0].id;
        }
      }
    },

    async fetchMoreProjects() {
      if (this.searchResults.length >= this.Project.total) {
        return; // No more projects to fetch
      }

      this.Project.setPage(this.Project.page + 1);
      await this.fetchProjects();
    },

    onIntersect(_a, _b, isIntersecting) {
      if (isIntersecting && this.Project.page < this.Project.totalPages) {
        this.fetchMoreProjects();
      }
    },

    onSelected() {
      this.Project.setPage(1);
    },
  },

  created() {
    this.Project = new Project({
      itemsPerPage: 10, // Set the number of items to fetch per page
      filters: {
        graduated: 0,
      },
      ...(this.operatorId && {
        tourism_operator_id: this.operatorId,
      }),
    });
    this.fetchProjects();
  },

  mounted() {
    this.mounted = true;
  },
};
</script>

<style lang="scss">
.autocomplete-container {
  position: relative;

  .scroll-target {
    height: 10px;
    width: 100%;
    display: block;
  }

  .v-autocomplete__content {
    border: 1px solid #c3c3c3;
  }

  .project-details-btn {
    z-index: +90;
  }

  .project-details {
    > aside {
      z-index: 10 !important;
    }

    //&.secondary-drawer {
    //  > aside {
    //    right: 680px !important;
    //  }
    //}
  }
}
</style>
